module.exports = __webpack_public_path__ + "img/20.d7d8f6e6.jpeg";